<template>
  <div class="content">
    <s-location mypage title="1:1 질의응답"/>
		<h4 class="sub_title02">1:1 질의응답 작성</h4>
      <table class="tbl01 view01 ">
        <tr>
				  <th class="al_c m_pl0">말머리</th>
          <td>
            <select v-model="sitem.SELKIND" @change="setKindCont()" >
              <option value="" selected="selected">선택</option>
              <option v-for="item in kind"
                      :value="item.SEQ"
                      :key="item.SEQ">{{item.TITL}}</option>
            </select>
          </td>
				</tr>
				<tr>
				  <th class="al_c m_pl0">제목</th>
          <td><i-input v-model="sitem.TITL" placeholder="제목" /></td>
				</tr>
        <tr>
          <th class="al_c m_pl0">파일첨부</th>
          <td class="infoamt">

            <i-fileupload name="file1" ref="file1" v-model="file1"
              :action="$api + '/attach'"
              autoUpload required
              kind="qna"
              :exts="'jpeg,jpe,jpg,gif,png,pdf'.split(/,/)"
              @done="file=>sitem.ATTACHID = file.uuid"
              >

              <template v-slot:dropArea="{isDropActive, files}">
                <div v-if="$mq != 'mobile' && !file1.name" class="file_drag" :style="{ 'background-color': isDropActive ? 'green' : 'gray' }">
                  Drag And Drop
                </div>
              </template>

              <template v-slot:uploadFile="{file, remove}">
                {{ file.name }} ( 용량 : {{ file.size | comma }} byte )
                <i-btn class="btn" @click.prevent="remove(file);sitem.ATTACHID=null" :key="file.id">취소</i-btn>
              </template>

              <button v-if="!file1 || !file1.name"
                class="btn xs gray01 outline btn_filesel">
                파일선택
              </button>
            </i-fileupload>
          </td>
        </tr>
        <tr>
				  <th class="al_c pc">내용</th>
          <td class="td_edit" colspan="2">
            <s-editor id="e1" height="300" v-model="sitem.CONT" placeholder="내용" />
          </td>
				</tr>
      </table>

      <div class="btn_group">
          <a class="btn" @click="doSubmit">등록하기</a>
          <a @click="$router.go(-1)" class="btn" style="margin-left: 20px; ">취소</a>
      </div>
  </div>

</template>

<script>
let ui
import _config from '../../plugins/config'

export default {
  data() {
    return {
      sitem : {SELKIND:''},
      file1 : {},
      kind  : [],
    }
  },
  created() {
    ui = this.$ui
    this.getKind()
  },

  methods: {

    getKind() { // 말머리 조회

      ui.httpGet('/mypage/qna_kind',{},
        ret => {
          this.kind = ret.data.kind
          })
    },

    setKindCont(){ // 선택한 말머리의 서식 채우기

      ui.httpGet('/mypage/qna_kind_view',
        {
          SEQ : this.sitem.SELKIND
        },
        ret => {
          // console.log("ret : ", ret)
          this.sitem.CONT = ret.data.CONT
          this.sitem.KIND = ret.data.TITL
          })
    },

    doSubmit() {

      if(T.isEmpty(this.sitem.SELKIND)){
        alert("말머리를 선택해 주세요.")
        return
      }
      if(T.isEmpty(this.sitem.TITL)){
        alert("제목을 입력해 주세요.")
        return
      }
      if(T.isEmpty(this.sitem.CONT)){
        alert("내용을 입력해 주세요.")
        return
      }

      this.itemUpdate()

    },

    itemUpdate(){

        ui.httpPost(
          "/mypage/qna_insert",
          this.sitem,
          ret => this.$router.push({path: '/mypage/qna'}),

        )

    },

  },
}
</script>